import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import {getModalHeaderText, getSubHeaderText} from './helpers';
import {InteractionPage} from './interaction-page';
import type {InteractionData} from './types';

type Props = {
    interactionModalData: InteractionData;
    isOpen: boolean;
    onClose: () => void;
};

export function InteractionModal(props: Props) {
    const handleCancel = () => {
        props.onClose();
    };

    return (
        <Modal
            headerText={getModalHeaderText(props.interactionModalData)}
            headerSubtext={getSubHeaderText(props.interactionModalData)}
            isOpen={props.isOpen}
            onClose={handleCancel}
        >
            <InteractionPage data={props.interactionModalData} onCancel={handleCancel} />
        </Modal>
    );
}
